import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { Subject } from 'rxjs';

import { AuthService } from '@shared/services/auth.service';
import { anonymiseEmail } from '@shared/utils';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./../login/login.component.scss'],
  standalone: false
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  resetForm: FormGroup;
  loading = false;
  submitted = false;
  success = false;
  email = '';
  tokenExpired: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (!params.tokenExpired) return;
      this.tokenExpired = params.tokenExpired;
      void this.router.navigate(['/reset-password']);
    });

    this.resetForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  resetPassword(): void {
    if (!this.resetForm.valid) {
      return;
    }

    // double click check
    if (this.loading) {
      return;
    }

    this.success = false;
    this.loading = true;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.email = this.resetForm.value.email;

    this.authService.resetPassword({ email: this.email }).subscribe(
      () => {
        this.cleanForm();
      },
      (error: { status: number; error: { errors: string[] }; url: string }) => {
        this.cleanForm();
        // TODO: Remove after Login issue investigation
        if (!error.status || error.status !== 404) {
          Sentry.captureException(new Error('Expection: Invalid customer login response'), {
            extra: {
              ...error,
              message: error.error.errors[0],
              hint: anonymiseEmail(this.email)
            },
            tags: {
              section: 'login'
            }
          });
        }
      }
    );
  }

  private cleanForm(): void {
    this.success = true;
    this.loading = false;
    this.resetForm.reset();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
